import { render, staticRenderFns } from "./registerModal.vue?vue&type=template&id=31a973f6"
import script from "./registerModal.vue?vue&type=script&lang=js"
export * from "./registerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports